// extracted by mini-css-extract-plugin
export var errorCode = "ErrorPage-module__errorCode___9Zk-G";
export var errorContainerRow = "ErrorPage-module__errorContainerRow___iMFZX";
export var textLight = "#595959";